import React from "react";
import { Box, IconButton, StarIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const IconButtonColors = () => {
  return (
    <Box p={3} sx={{ width: "80%", margin: "0 auto" }}>
      <PreviewAndEditor
        background
        title={"Color variations of rounded IconButtons"}
        height={"150px"}
        language={"js"}
        value={
          "       <IconButton>\n" +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton color={"primary"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton color={"secondary"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton color={"error"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton color={"warning"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton color={"info"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton color={"success"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton color={"inherit"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton color={"inheritWhite"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>"
        }
      >
        <IconButton>
          <StarIcon />
        </IconButton>
        <IconButton color={"primary"}>
          <StarIcon />
        </IconButton>
        <IconButton color={"secondary"}>
          <StarIcon />
        </IconButton>
        <IconButton color={"error"}>
          <StarIcon />
        </IconButton>
        <IconButton color={"warning"}>
          <StarIcon />
        </IconButton>
        <IconButton color={"info"}>
          <StarIcon />
        </IconButton>
        <IconButton color={"success"}>
          <StarIcon />
        </IconButton>
        <IconButton color={"inherit"}>
          <StarIcon />
        </IconButton>
        <IconButton color={"inheritWhite"}>
          <StarIcon />
        </IconButton>
      </PreviewAndEditor>
    </Box>
  );
};

export default IconButtonColors;
